import axios from "axios"

const notifyError = (error = "") => {
  const url =
    "https://hooks.slack.com/services/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"

  axios
    .post(url, JSON.stringify({ text: error }), {
      withCredentials: false,
      transformRequest: [
        (data, headers) => {
          delete headers.post["Content-Type"]
          return data
        },
      ],
    })
    .then((res) => console.log("failed operation logged"))

  return true
}

export default notifyError
